export default __webpack_public_path__ + "static/media/Belt of Lunacy.6b19e473.jpg";